import { FC, useCallback } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "../../components/buttons";
import {
    ImportSuccessModalBody,
    CloseModalIconWrapper,
    ImportModalHeaderRow,
    ImportModalTitle,
    ImportModalDescription,
    ImportSuccessButtonRow,
} from "./styles";
import { BrgButton, ButtonVariant } from "@brg/ui";

export const ImportProjectSuccessModal: FC = () => {
    const modal = useModal();
    const { t } = useTranslation();

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    return (
        <ImportSuccessModalBody>
            <ImportModalHeaderRow>
                <ImportModalTitle>{t("import_project_modal.success_title")}</ImportModalTitle>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </ImportModalHeaderRow>
            <ImportModalDescription>{t("import_project_modal.success_description")}</ImportModalDescription>
            <ImportSuccessButtonRow>
                <BrgButton variant={ButtonVariant.Filled} width={153} onClick={onClose}>
                    {t("import_project_modal.success_btn")}
                </BrgButton>
            </ImportSuccessButtonRow>
        </ImportSuccessModalBody>
    );
};
import { FC, useCallback } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "../../components/buttons";
import {
    ImportSuccessModalBody,
    CloseModalIconWrapper,
    ImportModalHeaderRow,
    ImportModalTitle,
    ImportModalDescription,
    ImportSuccessButtonRow,
} from "./styles";
import { BrgButton, ButtonVariant } from "@brg/ui";

export const ImportProjectSuccessModal: FC = () => {
    const modal = useModal();
    const { t } = useTranslation();

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    return (
        <ImportSuccessModalBody>
            <ImportModalHeaderRow>
                <ImportModalTitle>{t("import_project_modal.success_title")}</ImportModalTitle>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </ImportModalHeaderRow>
            <ImportModalDescription>{t("import_project_modal.success_description")}</ImportModalDescription>
            <ImportSuccessButtonRow>
                <BrgButton variant={ButtonVariant.Filled} width={153} onClick={onClose}>
                    {t("import_project_modal.success_btn")}
                </BrgButton>
            </ImportSuccessButtonRow>
        </ImportSuccessModalBody>
    );
};
